import { createAsyncThunk } from "@reduxjs/toolkit";
import { AUDIT } from "constants/api";
import axios from "utils/http";

interface IFetchAuditTrailResponse extends ApiResponse {
  data: IAuditTrailData;
}

interface IFetchAuditTrailArgs extends ReduxAction {
  page: number;
}

export const fetchAuditTrail = createAsyncThunk(
  AUDIT.TRAIL,
  async ({ page, onFailure }: IFetchAuditTrailArgs, { rejectWithValue }) => {
    try {
      const { data }: IFetchAuditTrailResponse = await axios.get(
        `${AUDIT.TRAIL}?page=${page}`
      );

      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
